<template>
  <div class="card p-2">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>Device ID</th>
          <th class="text-center">Status</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in devices" :key="item.id">
          <td>{{ i + 1 }}</td>
          <td>{{ item.device_id }}</td>
          <td class="text-center">
            <div class="form-check form-switch d-flex align-items-center justify-content-center gap-2 ps-0 mb-0">
              <input
                  class="form-check-input m-0"
                  type="checkbox"
                  role="switch"
                  :id="`device-status-${item.id}`"
                  :checked="isActive(item.status)"
                  @change="$emit('onToggleStatus', item, $event)"
              />
              <label class="form-check-label" :for="`device-status-${item.id}`">
                {{ statusLabel(item.status) }}
              </label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!devices.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  devices: {
    type: Array,
    default: () => []
  }
})

defineEmits(['onToggleStatus'])

function isActive(status) {
  return status === 'active'
}

function statusLabel(status) {
  if (isActive(status)) return 'Active'
  return 'Inactive'
}
</script>
